module.exports = __webpack_public_path__ + "static/media/vctr-contract.12fd1ab7.svg";